module.exports = __webpack_public_path__ + "static/media/iStock-118262294.a04bec2f.jpg";